/*!
 * valino-ab.js — lightweight A/B framework runtime
 *
 * Reads <script type="application/json" data-valino-ab="exp_name">…</script>
 * tags emitted by snippets/valino-ab-test.liquid, assigns a deterministic
 * variant per visitor, reports to GA4 (gtag), and exposes window.valinoAB.
 *
 * No dependencies. Safe no-op if localStorage/gtag unavailable.
 */
(function () {
  if (window.valinoAB) return;

  var STORE_KEY = 'valino_ab_v1';
  var store;
  try { store = JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (_) { store = {}; }

  function save() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(store)); } catch (_) {}
  }

  function gtagSafe() {
    if (typeof window.gtag === 'function') {
      try { window.gtag.apply(null, arguments); } catch (_) {}
    }
  }

  function hash(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) - h) + str.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h);
  }

  function ensureVisitorId() {
    if (!store.__vid) {
      store.__vid = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      save();
    }
    return store.__vid;
  }

  function pickVariant(experiment, variants) {
    var vid = ensureVisitorId();
    var bucket = hash(vid + ':' + experiment) % variants.length;
    return variants[bucket];
  }

  window.valinoAB = {
    get: function (exp) { return store[exp] || null; },
    all: function () {
      var out = {};
      for (var k in store) { if (k !== '__vid' && Object.prototype.hasOwnProperty.call(store, k)) out[k] = store[k]; }
      return out;
    },
    // Escape hatch for QA: window.valinoAB.force('exp','variant')
    force: function (exp, variant) {
      if (!exp || !variant) return null;
      store[exp] = variant;
      save();
      document.documentElement.setAttribute('data-ab-' + exp.replace(/_/g, '-'), variant);
      return variant;
    }
  };

  function processNode(node) {
    try {
      var cfg = JSON.parse(node.textContent || '{}');
      var exp = cfg.experiment;
      var variants = Array.isArray(cfg.variants) ? cfg.variants : null;
      if (!exp || !variants || !variants.length) return;

      if (!store[exp] || variants.indexOf(store[exp]) === -1) {
        store[exp] = pickVariant(exp, variants);
        save();
      }

      document.documentElement.setAttribute('data-ab-' + exp.replace(/_/g, '-'), store[exp]);

      var sessionKey = 'valino_ab_reported_' + exp;
      var alreadyReported = false;
      try { alreadyReported = !!sessionStorage.getItem(sessionKey); } catch (_) {}
      if (!alreadyReported) {
        gtagSafe('event', 'experiment_impression', {
          experiment_id: exp,
          variant_id: store[exp]
        });
        try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
      }
    } catch (_) { /* swallow: one bad tag must not break others */ }
  }

  function run() {
    var nodes = document.querySelectorAll('script[data-valino-ab]');
    for (var i = 0; i < nodes.length; i++) processNode(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
